import React from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { actionLogout } from '../../../actions/user';
import { bindActionCreators } from "redux";
import { isEmptyJSON } from "../../../functions/ValidationState";

const NavbarDefault = ({ user: { data }, actionLogout }) => {

   const handleLogout = () => {
      actionLogout();
   }

   return (
      <div className = "navbar navbar-default navbar-static-top m-b-0">
         <div className = "navbar-header">
            <a className =  "navbar-toggle hidden-sm hidden-md hidden-lg">
               <i className = "ti-menu"></i>
            </a>
            <div className = "top-left-part">
               <Link className = "logo" to = "/">
                  <b>
                     <img src = { 'https://res.cloudinary.com/dlaew2qjk/image/upload/v1668026226/logos_clientes/img-logo-notaria84-mix.png' } style = {{ paddingLeft: '20px'}} width = "210px" alt = "inicio" />
                  </b>
               </Link>
            </div>
            <ul className = "nav navbar-top-links navbar-left hidden-xs">
               <li><a href="#" className="open-close hidden-xs waves-effect waves-light"><i className="icon-arrow-left-circle ti-menu"></i></a></li>
            </ul>
            <ul className = "nav navbar-top-links navbar-right pull-right">
               <li className = "dropdown">
                  {
                     isEmptyJSON(data) ?
                        <a className = "dropdown-toggle profile-pic" data-toggle="dropdown" href="#">
                           <img src = "https://res.cloudinary.com/dlaew2qjk/image/upload/v1542218693/assets/static/photo.png" alt = "" width="36" className = "img-circle" />
                           <b className = "hidden-xs"> { data.displayName } </b>
                        </a>
                     : null
                  }
                  <ul className = "dropdown-menu dropdown-user animated flipInY">
                     <li><Link to="/perfil"><i className="ti-user"></i> Mi Perfil </Link></li>
                     <li><a href="#" onClick={ handleLogout }><i className="fa fa-power-off"></i> Salir </a></li>
                  </ul>
               </li>
            </ul>
         </div>
      </div>
   )
};

function mapStateToProps ( state ) {
   return {
      user : state.user
   }
}

function mapDispatchToProps ( dispatch ) {
   return bindActionCreators({
      actionLogout
   }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(NavbarDefault);